import React, {  useEffect } from "react";
import { useNavigate } from "react-router-dom";

const LiveLayout = (props) => {
  const navigate = useNavigate();

  useEffect(() => {
    window.addEventListener('mention-clicked', (e) => {
      navigate(e.value.link)
    })
  }, [])

  return <>{React.cloneElement(props.children)}</>;
};

export default LiveLayout;
